import React from 'react';
import './Community.css';

// Fotos de tours
import tourCdmx from '../../assets/logos/doggy_tour_cdmx.jpeg';
import tourGdl from '../../assets/logos/doggy_tour_Guadalajara.jpeg';
import tourMty from '../../assets/logos/doggy_tour_monterrey.jpeg';
import tourQro from '../../assets/logos/doggy_tour_queretaro2.webp';

// Fotos de la Comunidad Doggy
import photoIMPLS from '../../assets/logos/@IMPLS1999.jpg';
import photoCheCoinsol from '../../assets/logos/@checoinsol .jpg';
import photoEsteban from '../../assets/logos/@esteban_za8244.jpg';
import photoCrisScheme from '../../assets/logos/@CrisScheme.jpg';
import photoGalle from '../../assets/logos/@galle_35 .jpg';
import photoAlphadegen from '../../assets/logos/@alphadegenn.jpg';

/**
 * SECCIÓN 5: COMUNIDAD DOGGY
 * Parte 1: Doggy Tours — recorridos físicos por ciudades
 * Parte 2: Héroes — gente activa en la comunidad
 */

const tours = [
  {
    id: 1,
    ciudad: 'CDMX',
    emoji: '🏙️',
    photo: tourCdmx,
    fecha: 'Noviembre 2025',
  },
  {
    id: 2,
    ciudad: 'Guadalajara',
    emoji: '🌮',
    photo: tourGdl,
    fecha: 'Diciembre 2025',
  },
  {
    id: 3,
    ciudad: 'Monterrey',
    emoji: '🏔️',
    photo: tourMty,
    fecha: 'Enero 2026',
  },
  {
    id: 4,
    ciudad: 'Querétaro',
    emoji: '⛪',
    photo: tourQro,
    fecha: '2026',
    portrait: true,
  },
];

const heroes = [
  {
    id: 1,
    name: '@IMPLS1999',
    photo: photoIMPLS,
    contribution: 'Un álbum completo en Spotify',
    badge: '🎵 Álbum Oficial',
    handle: 'IMPLS1999',
  },
  {
    id: 2,
    name: '@chebtcsol',
    photo: photoCheCoinsol,
    contribution: 'Programa de insignias de la comunidad',
    badge: '🏅 Insignias',
    handle: 'chebtcsol',
  },
  {
    id: 3,
    name: '@esteban_za8244',
    photo: photoEsteban,
    contribution: 'Maneja el X en inglés de DOGGY',
    badge: '🌐 X en Inglés',
    handle: 'esteban_za8244',
  },
  {
    id: 4,
    name: '@CrisScheme',
    photo: photoCrisScheme,
    contribution: 'Creador del mini game Doggy Jump',
    badge: '🎮 Mini Game',
    handle: 'CrisScheme',
  },
  {
    id: 5,
    name: '@galle_35',
    photo: photoGalle,
    contribution: 'Torneos de Clash Royale con +1M en premios',
    badge: '🏆 Torneos',
    handle: 'galle_35',
  },
  {
    id: 6,
    name: '@alphadegenn',
    photo: photoAlphadegen,
    contribution: 'Quemando millones de $DOGGY',
    badge: '🔥 Quemando Millones',
    handle: 'alphadegenn',
  },
];

const CommunityTours = () => {
  return (
    <section className="community section" id="comunidad">
      <div className="container">

        {/* ===== DOGGY TOURS ===== */}
        <div className="community__tours">
          <div className="community__tours-grid">
            {tours.map((tour, index) => (
              <div 
                key={tour.id} 
                className={`community__tour-card ${tour.photo ? '' : 'community__tour-card--coming'} ${tour.portrait ? 'community__tour-card--portrait' : ''}`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {tour.photo ? (
                  <div className={`community__tour-photo ${tour.portrait ? 'community__tour-photo--portrait' : ''}`}>
                    <img src={tour.photo} alt={`Doggy Tour ${tour.ciudad}`} loading="lazy" />
                  </div>
                ) : (
                  <div className="community__tour-placeholder">
                    <span className="community__tour-emoji">{tour.emoji}</span>
                  </div>
                )}
                <div className="community__tour-info">
                  <span className="community__tour-emoji-label">{tour.emoji}</span>
                  <h3 className="community__tour-city">{tour.ciudad}</h3>
                  <span className="community__tour-date">{tour.fecha}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

const CommunityHeroes = () => {
  return (
    <section className="community section">
      <div className="container">

        {/* ===== LA MANADA ===== */}
        <div className="community__heroes">
          <span className="community__label">🐕 La manada</span>
          <h2 className="community__title">Comunidad Doggy</h2>
          <p className="community__subtitle">
            No es solo un token. <strong>Hay gente real haciendo cosas.</strong>
          </p>

          <div className="community__heroes-grid">
            {heroes.map((hero, index) => (
              <a 
                key={hero.id} 
                className="community__hero-card"
                href={`https://x.com/${hero.handle}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ animationDelay: `${index * 120}ms` }}
              >
                <div className="community__hero-photo">
                  <img src={hero.photo} alt={hero.name} loading="lazy" />
                </div>
                <span className="community__hero-badge">{hero.badge}</span>
                <h3 className="community__hero-name">{hero.name}</h3>
                <p className="community__hero-contribution">{hero.contribution}</p>
              </a>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export { CommunityTours, CommunityHeroes };
export default CommunityTours;
